import { useContext } from 'react'
import { modalContext } from 'providers/modal'

const useModal = (variant) => {

  const { data, setData } = useContext(modalContext)

  const open = (props) => setData({ variant, props})

  const close = () => setData({})

  const toggle = (props) => {
    setData(prev => {
      if (prev.variant) return {}
      return { variant, props }
    })
  }

  const Modal = {
    isOpen: !!data.variant,
    open,
    close,
    toggle
  }

  return { Modal }
}

export default useModal